export var PlatformEventType;
(function (PlatformEventType) {
    PlatformEventType["FilePublished"] = "file.published";
    PlatformEventType["FileUnpublished"] = "file.unpublished";
    PlatformEventType["TranscriptPublished"] = "transcript.published";
    PlatformEventType["TranscriptUnpublished"] = "transcript.unpublished";
})(PlatformEventType || (PlatformEventType = {}));
export var GenAIBrokerTopic;
(function (GenAIBrokerTopic) {
    GenAIBrokerTopic["Acknowledgements"] = "acknowledgements";
    GenAIBrokerTopic["PlatformEvents"] = "platform-events";
    GenAIBrokerTopic["PlatformEventsDeadLetter"] = "platform-events.dead-letter";
})(GenAIBrokerTopic || (GenAIBrokerTopic = {}));
export var GenAIBrokerQueue;
(function (GenAIBrokerQueue) {
    GenAIBrokerQueue["Acknowledgements"] = "acknowledgements.queue";
    GenAIBrokerQueue["PlatformEventsDLQ"] = "platform-events.dead-letter.queue";
    GenAIBrokerQueue["FilePublishing"] = "file.publishing.queue";
    GenAIBrokerQueue["TranscriptPublishing"] = "transcript.publishing.queue";
})(GenAIBrokerQueue || (GenAIBrokerQueue = {}));
export const GenAIBrokerTopicToQueueMap = {
    [GenAIBrokerTopic.Acknowledgements]: [GenAIBrokerQueue.Acknowledgements],
    [GenAIBrokerTopic.PlatformEventsDeadLetter]: [GenAIBrokerQueue.PlatformEventsDLQ],
    [GenAIBrokerTopic.PlatformEvents]: [
        GenAIBrokerQueue.FilePublishing,
        GenAIBrokerQueue.TranscriptPublishing,
    ],
};
export var P2PEntityType;
(function (P2PEntityType) {
    P2PEntityType["Brand"] = "brand";
    P2PEntityType["ConferenceTag"] = "conferenceTag";
    P2PEntityType["File"] = "file";
    P2PEntityType["FileVersion"] = "fileVersion";
    P2PEntityType["Folder"] = "folder";
    P2PEntityType["Project"] = "project";
    P2PEntityType["ProjectParent"] = "projectParent";
    P2PEntityType["Transcript"] = "transcript";
    P2PEntityType["TranscriptEntity"] = "transcriptEntity";
})(P2PEntityType || (P2PEntityType = {}));
